import { useState } from "react";
import { Card, Tabs } from "antd";
import TabPane from "antd/lib/tabs/TabPane";
import Discounts from "./Discounts";

import "./styles.css";
import SingleUseDiscounts from "./SingleUseDiscounts";
import DiscountMessage from "./DiscountMessage";

const ManageDiscounts = () => {
  const [activeKey, setActiveKey] = useState("discounts");
  return (
    <div className="discounts-wrapper">
      <Card>
        <Tabs
          activeKey={activeKey}
          defaultActiveKey="discounts"
          onChange={(v) => setActiveKey(v)}
        >
          <TabPane tabKey="discounts" key={"discounts"} tab="Discounts">
            <Discounts />
          </TabPane>
          <TabPane
            tabKey="single-use"
            key={"single-use"}
            tab="Single Use Discounts"
          >
            <SingleUseDiscounts />
          </TabPane>
          <TabPane
            tabKey="discount-message"
            key={"discount-message"}
            tab="Discount Message"
          >
            <DiscountMessage />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default ManageDiscounts;
